import { gql } from "@apollo/client";

export const FRAGMENT_MEETING_SETTINGS = gql`
  fragment MeetingSettings on MeetingSettings {
    id
    slug
    isActive
    name
    description
    bookableHours
    availabilityType
    bookOnNoMeetingDay
    highlightBestTimes
    allowFifteenMinuteMarkBooking
    bookingTimeBufferHours
    timingSettings {
      durationMinutes
      periodType
      timeRange {
        rangeStartTimeMillis
        rangeEndTimeMillis
        windowSizeDays
        timeZone
      }
    }
    locationSettings {
      locationType
      locationDetails
    }
  }
`;

export const FRAGMENT_ERROR = gql`
  fragment GraphEntityErrorFragment on GraphEntityError {
    statusCode
    message
    body
  }
`;

export const linkSettingsQuery = gql`
  ${FRAGMENT_MEETING_SETTINGS}
  ${FRAGMENT_ERROR}
  query MeetingSettingsQuery($slug: String!, $createLinkNameIfNone: Boolean = true) {
    viewer {
      user {
        linkNameErrorable(createLinkNameIfNone: $createLinkNameIfNone) {
          ...GraphEntityErrorFragment
          ... on LinkName {
            linkName
          }
        }
        familyName
        givenName
        meetingSettingsErrorable(slug: $slug) {
          ...GraphEntityErrorFragment
          ...MeetingSettings
        }
        orgs {
          edges {
            node {
              id
              name
              experiments
              workingGroups {
                edges {
                  node {
                    id
                  }
                }
              }
              zoomAccount {
                ... on ZoomAccount {
                  id
                  hasValidZoomAccount
                }
                ... on GraphEntityError {
                  message
                  statusCode
                  body
                }
              }
              zoomUserLevelAccount {
                ... on ZoomAccount {
                  id
                  hasValidZoomAccount
                }
                ... on GraphEntityError {
                  message
                  statusCode
                  body
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const createMeetingSettings = gql`
  ${FRAGMENT_MEETING_SETTINGS}
  ${FRAGMENT_ERROR}
  mutation CreateMeetingSettings($input: CreateMeetingSettingsInput!) {
    createMeetingSettings(input: $input) {
      meetingSettingsErrorable {
        ...GraphEntityErrorFragment
        ...MeetingSettings
      }
    }
  }
`;

export const updateMeetingSettings = gql`
  ${FRAGMENT_MEETING_SETTINGS}
  ${FRAGMENT_ERROR}
  mutation UpdateMeetingSettings($input: UpdateMeetingSettingsInput!) {
    updateMeetingSettings(input: $input) {
      meetingSettingsErrorable {
        ...GraphEntityErrorFragment
        ...MeetingSettings
      }
    }
  }
`;

export const deleteMeetingSettings = gql`
  mutation DeleteMeetingSettings($input: DeleteMeetingSettingsInput!) {
    deleteMeetingSettings(input: $input) {
      __typename
    }
  }
`;
